import React from "react";
import prodA from "../assets/products/die-cutting-progressive-part.png";
import prodB from "../assets/products/packaging-product-progressive-part.png";
import prodC from "../assets/products/hot-die-cutting-part.png";
import prodD from "../assets/products/air-conditioner.png";

const Product = () => {
  const products = [
    {
      id: 1,
      title: "Die-Cutting Progressive Part",
      image: prodA,
      description:
        "Produk hasil proses pemotongan berlapis menggunakan teknologi Progressive Die-Cutting. Cocok untuk kebutuhan otomotif dan elektronik yang memerlukan presisi tinggi serta efisiensi produksi. Proses ini menghasilkan komponen foam, felt, dan adhesive parts dengan akurasi dimensi yang stabil.",
    },
    {
      id: 2,
      title: "Packaging Product & Part",
      image: prodB,
      description:
        "Komponen kemasan industri yang dirancang khusus untuk melindungi part otomotif dan elektronik dari benturan dan goresan. Menggunakan bahan PE foam, EPE, laminated sheet, dan material ringan lain yang tahan lama.",
    },
    {
      id: 3,
      title: "Hot Die-Cutting Progressive Part",
      image: prodC,
      description:
        "Proses pemotongan panas berpresisi tinggi untuk material adhesive, insulasi, dan foam. Cocok untuk komponen yang memerlukan bentuk kompleks dan ketahanan suhu tinggi pada sistem elektronik dan AC.",
    },
    {
      id: 4,
      title: "Air Conditioner (AC) Part",
      image: prodD,
      description:
        "Komponen pendukung sistem pendingin udara kendaraan, seperti insulator, ducting foam, dan sealing gasket. Didesain untuk meningkatkan efisiensi pendinginan, mengurangi kebisingan, dan memperpanjang usia sistem HVAC.",
    },
  ];

  return (
    <section
      id="product"
      style={{
        background: "linear-gradient(135deg, #bbf7d0, #fef08a, #fcffbf)",
        padding: "5rem 2rem",
      }}
    >
      {/* Judul */}
      <div style={{ textAlign: "center", marginBottom: "3rem" }}>
        <h2
          style={{
            fontSize: "2.3rem",
            fontWeight: "bold",
            color: "#111827",
            marginBottom: "0.75rem",
          }}
        >
          Our Product Catalog
        </h2>
        <p
          style={{
            color: "#4b5563",
            maxWidth: "750px",
            margin: "0 auto",
            fontSize: "1.05rem",
            lineHeight: "1.7",
          }}
        >
          Berikut adalah kategori utama produk dan komponen industri yang kami
          hasilkan untuk mendukung sektor otomotif dan elektronik modern.
        </p>
      </div>

      {/* Grid Utama */}
      <div className="product-grid">
        {products.map((prod) => (
          <div
            key={prod.id}
            className="product-card"
            style={{
              display: "flex",
              flexDirection: "row",
              background: "white",
              borderRadius: "18px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
              overflow: "hidden",
              height: "380px",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-8px)";
              e.currentTarget.style.boxShadow = "0 14px 30px rgba(0,0,0,0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.1)";
            }}
          >
            {/* Gambar */}
            <div
              className="product-image"
              style={{
                flex: "1 1 45%",
                overflow: "hidden",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f3f4f6",
              }}
            >
              <img
                src={prod.image}
                alt={prod.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  transition: "transform 0.6s ease",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.transform = "scale(1.03)")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.transform = "scale(1.0)")
                }
              />
            </div>

            {/* Deskripsi */}
            <div
              className="product-desc"
              style={{
                flex: "1 1 55%",
                padding: "2rem 2.5rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                textAlign: "justify",
              }}
            >
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "bold",
                  color: "#111827",
                  marginBottom: "1rem",
                }}
              >
                {prod.title}
              </h3>
              <p
                style={{
                  color: "#4b5563",
                  fontSize: "1rem",
                  lineHeight: "1.9",
                }}
              >
                {prod.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* CSS Responsif */}
      <style>
        {`
          .product-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
            gap: 2.5rem;
            max-width: 1400px;
            margin: 0 auto;
          }

          /* Desktop */
          @media (min-width: 1024px) {
            .product-grid {
              grid-template-columns: repeat(auto-fit, minmax(600px, 1fr));
            }
          }

          /* Mobile */
          @media (max-width: 768px) {
            .product-card {
              flex-direction: column !important;
              height: auto !important;
              width: 100%;
            }
            .product-image {
              width: 100%;
              height: 230px;
            }
            .product-desc {
              padding: 1.5rem !important;
            }
            .product-desc h3 {
              text-align: center !important;
              font-size: 1.4rem !important;
            }
            .product-desc p {
              text-align: justify;
              font-size: 1rem;
            }
          }
        `}
      </style>
    </section>
  );
};

export default Product;
